import React from 'react';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
} from '../../components/Form';


import {
    Title,
    TextView,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffOrdersCopy(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handleCancel = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handleCopyOrder = async () => {
        await postData('/api/panel/page/taroff-orders-copy/save-data', {});
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    return (
        <PanelBox>
            <Title>کپی سفارش</Title>
            <TextView></TextView>
            <DataForm>
                <Title>ایجاد سفارش</Title>
                <LeftComponents>
                                    <Button onClick={handleCancel}>انصراف</Button>
                <Button onClick={handleCopyOrder}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
